module.exports = __webpack_public_path__ + "img/19.003e8edc.svg";